import { render } from "./SalesWerving.vue?vue&type=template&id=5cd6b914&scoped=true"
import script from "./SalesWerving.vue?vue&type=script&lang=js"
export * from "./SalesWerving.vue?vue&type=script&lang=js"

import "./SalesWerving.vue?vue&type=style&index=0&id=5cd6b914&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd6b914"]])

export default __exports__